import { MSPQRadioGroupType, PreRegMakeSelectionOptionsType } from './types';

export const MSPQRadioGroupOptions: MSPQRadioGroupType[] = [
  { key: 'employed', title: 'Are you currently employed?' },
  { key: 'spouseEmployed', title: 'Do you have a spouse who is currently employed?' },
  {
    key: 'groupHealth',
    title:
      'Do you have a Group Health Plan coverage based on your own employment, your spouse or a family member?'
  },
  { key: 'blackLung', title: 'Are you receiving Black Lung benefits?' },
  {
    key: 'governmentSearch',
    title: 'Are the services to be paid by a government research program?'
  },
  {
    key: 'dva',
    title:
      'Has the Department of Veteran Affairs (DVA) authorized and agreed to pay for care at this facility?'
  },
  {
    key: 'workRelated',
    title: 'Was the illness/injury due to the following: work-related, auto, other accident?'
  }
];

export const PreRegMakeSelectionOptions: PreRegMakeSelectionOptionsType[] = [
  { label: 'I prefer to pay upon arrival', code: 1 },
  { label: 'I prefer to pay upon arrival and would like to set up a payment plan', code: 2 },
  { label: 'I prefer to pay later', code: 8 },
  { label: 'I prefer to pay later and would like to set up a payment plan', code: 2 },
  { label: 'I am not able to pay and I would like to speak to a financial counselor', code: 3 },
  { label: 'There is an issue with the cost estimate that requires follow up', code: 9 },
  { label: 'I would like to speak to a Registrar', code: 12 }
];

export const PreRegUploadPhotoText = {
  description: 'Please upload your photo ID',
  noActionRequired: 'Children under 5 do not require a photo ID',
  over18: `Valid forms include a drivers license, state issued ID or passport`,
  skip: 'Skip for now and provide ID at appointment',
  title: 'Photo Identification',
  under18: `Valid forms include any recent picture of the child's full face, preferably a school id or passport. A plain picture of the child will suffice if the child has no photo id.`
};

export const PreRegAdditionalInfoText = {
  accidentDate: 'Accident Date',
  accidentHow: 'How did the accident happen?',
  accidentLastWorked: 'When was the last date you worked?',
  accidentState: 'In what state did the accident happen?',
  accidentType: 'What type of accident was this?',
  accidentTypes: [
    'Accident W/ Attorney Involved',
    'Accident w/ TPL Coverage',
    'Automobile Accident',
    'Crime Victim',
    'Employment Related',
    'Other Accident'
  ],
  accidentWhere: 'Where did the accident happen?',
  accidentTime: 'Accident Time',
  accidentSummary: 'Accident Summary',
  accidentSummaryInfo1:
    'Please describe what you were doing at the time and what happened to cause the injury/condition.',
  accidentSummaryInfo2:
    'For example, you might say something like, “I was exercising and while running, I tripped and fell to the ground and broke my arm.”',
  attendingPhysician: 'Attending/Rendering Physician',
  description: 'Please verify your additional information and update as needed.',
  chooseOne: 'Choose one',
  covid: 'Are you experiencing any of the following symptoms? (COVID-19 screening)',
  covidSymptoms: [
    'Chills',
    'Cough',
    'Diarrhea, nausea, or vomiting',
    'Fever',
    'Shortness of breath',
    'Sore throat',
    'Lost sense of smell',
    'Multiple symptoms',
    'No symptoms'
  ],
  isAccident: 'Is this condition accident related?',
  lastSeen: 'When did you last see a doctor about this?',
  maxText: 'character max',
  pcp: 'Who is your Primary Care Physician (PCP)?',
  referringPhysician: 'Referring Physician',
  skip: 'Skip for now and provide information at appointment',
  title: 'Additional Identification',
  travel: 'Have you traveled outside the U.S. in the last 21 days?',
  travelLocations: [
    'Asia',
    'Central Africa - Dem. Rep. of Congo',
    'Middle East - Arabian Peninsula',
    'None of these locations'
  ],
  whichLocation: 'Which Location?'
};

export const infoDefinitions = [
  {
    Term: 'Estimated charges before insurance',
    Definition:
      'This amount reflects your estimated balance before discounts from negotiated rates and before the amount to be paid by your insurance.'
  },
  {
    Term: null,
    Definition:
      'Your final bill will reflect the actual charges for the services provided and may be more or less than this estimate.'
  },
  {
    Term: null,
    Definition:
      'If your final bill is less than this estimate, you will be refunded the difference. You may also receive additional bills from physicians and other providers involved in your care. Their charges are not included in this estimate.'
  }
];

export const errors = {
  PhotoID: 'Photo ID step failed to update and is not complete. Please try again later.',
  PatientInfo:
    'Personal Information step failed to update and is not complete. Please try again later.',
  Mspq: 'MSPQ step failed to update. Please try again later',
  Insurance: 'Insurance ID failed to update. Please try again later.',
  InsuranceSecondary: 'Secondary insurance ID failed to update. Please try again later.',
  GuarantorInfo: 'Guarantor step failed to update. Please try again later.',
  ConsentForm: 'Consent Form step failed to update',
  Complete: 'You have already completed this step'
};

export const selfPayInsuranceCodes = ['', null, '0018', '0057'];

export const MAX_FILE_SIZE = 10;
export const MAX_DIMENSIONS = 1080;
